// Ensure that the client API is initialized by the framework before any other iframe code
    // is loaded. That way our client-apis can assume the existence of the API+store
    import { configure } from '@storybook/react';

    import * as clientApi from "@storybook/client-api";
    import { logger } from '@storybook/client-logger';
    import * as config_0 from '@storybook/react/dist/esm/client/docs/config'
import * as config_1 from '@storybook/react/dist/esm/client/preview/config'
import * as config_2 from '@storybook/addon-links/preview.js'
import * as config_3 from '@storybook/addon-docs/preview.js'
import * as config_4 from '@storybook/addon-actions/preview.js'
import * as config_5 from '@storybook/addon-backgrounds/preview.js'
import * as config_6 from '@storybook/addon-measure/preview.js'
import * as config_7 from '@storybook/addon-outline/preview.js'
import * as config_8 from '@storybook/addon-interactions/preview.js'
    import * as preview from '/virtual:/@storybook/builder-vite/preview-entry.js';
    import { configStories } from '/virtual:/@storybook/builder-vite/storybook-stories.js';

    const {
      addDecorator,
      addParameters,
      addLoader,
      addArgTypesEnhancer,
      addArgsEnhancer,
      setGlobalRender,
    } = clientApi;

    const configs = [config_0,config_1,config_2,config_3,config_4,config_5,config_6,config_7,config_8,preview.default].filter(Boolean)

    configs.forEach(config => {
      Object.keys(config).forEach((key) => {
        const value = config[key];
        switch (key) {
          case 'args': {
            if (typeof clientApi.addArgs !== "undefined") {
              return clientApi.addArgs(value);
            } else {
              return logger.warn(
                "Could not add global args. Please open an issue in storybookjs/builder-vite."
              );
            }
          }
          case 'argTypes': {
            if (typeof clientApi.addArgTypes !== "undefined") {
              return clientApi.addArgTypes(value);
            } else {
              return logger.warn(
                "Could not add global argTypes. Please open an issue in storybookjs/builder-vite."
              );
            }
          }
          case 'decorators': {
            return value.forEach((decorator) => addDecorator(decorator, false));
          }
          case 'loaders': {
            return value.forEach((loader) => addLoader(loader, false));
          }
          case 'parameters': {
            return addParameters({ ...value }, false);
          }
          case 'argTypesEnhancers': {
            return value.forEach((enhancer) => addArgTypesEnhancer(enhancer));
          }
          case 'argsEnhancers': {
            return value.forEach((enhancer) => addArgsEnhancer(enhancer))
          }
          case 'render': {
            return setGlobalRender(value)
          }
          case 'globals':
          case 'globalTypes': {
            const v = {};
            v[key] = value;
            return addParameters(v, false);
          }
          case 'decorateStory':
          case 'applyDecorators':
          case 'renderToDOM': {
            return null; // This key is not handled directly in v6 mode.
          }
          default: {
            // eslint-disable-next-line prefer-template
            return console.log(key + ' was not supported :( !');
          }
        }
      });
    })
    
    /* TODO: not quite sure what to do with this, to fix HMR
    if (import.meta.hot) {
        import.meta.hot.accept();    
    }
    */

    configStories(configure);